
/**
 *     Data-driven UI that displays a graphical tree interface
 *
 *     @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *     Created on 05/09/2018
 *     Modified on 04/06/2020
 */

/**
 * Navigate to selected leaf node.
 * @param target {object} leaf node DOM element.
 */
function navigateToLeafNode( target ) {
    var text,
        id,
        type,
        alias,
        url;

    if ( target && $(target)) {

        // Search UI leaf node
        text = $(target).find('.nodeText');

        // Query Manager Web leaf node
        if ( $(text).length === 0 ) {
            text = $(target).find('.node-text');
        }


        if ( text && $( text ) ) {
            id = $( text ).attr("id");

            type = $( text ).attr("node_type");

            if ( id ) {

                if ( GlobalPageState && ! type ) {
                    type = GlobalPageState.type;
                }

                if ( type && id && App && App.globalState ) {
                    alias = App.globalState.alias;
                }
                if ( alias ) {
                    url = '/view/' + alias + '/' + type + '/' + id;
                } else {
                    url = '/view/' + type + '/' + id;
                }

                router.navigate( url, { trigger: true } );
            }
        }
    }
}

/**
 * Get current page number from pagination DOM element
 * @param el {object} - pagination element
 * @return {*}
 */
function getCurrentPageNumber( el ) {

    var pageNumber,
        pages,
        text,
        pageArray,
        pageSubstring,
        pageSubstringArray,
        page;

    // Get pagination element
    if ( el ) {

        pages = el.siblings('.pull-middle');

        if ( pages ) {

            text = pages.text();

            // Get page number from the text
            if ( text ) {

                pageArray = text.split( "page " );

                if ( pageArray && pageArray.length === 2 ) {

                    pageSubstring = pageArray[ 1 ];

                    if ( pageSubstring ) {

                        pageSubstringArray = pageSubstring.split(" out of ");

                        if ( pageSubstringArray && pageSubstringArray.length === 2 ) {
                            page = pageSubstringArray[ 0 ];
                            pageNumber = Number( page );

                        }
                    }
                }
            }
        }
    }

    return pageNumber;

}

/**
 * Get total number of pages from tree pagination DOM element.
 * @param el {object} Tree pagination element.
 * @return {*}
 */
function getNumberOfPages( el ) {

    var result,
        pages,
        text,
        pageArray,
        nPages;

    if ( el ) {

        pages = el.siblings('.pull-middle');

        if ( pages ) {

            text = pages.text();

            // Get total number of pages from the text
            if ( text ) {

                pageArray = text.split("out of ");

                if ( pageArray && pageArray.length === 2 ) {

                    nPages = pageArray[ 1 ];
                    result = Number( nPages );
                }
            }
        }
    }
    return result;
}

/**
 * Get current tree branch order (i.e. 1, 2, 3, 4 or 5).
 * @param el {object} pagination DOM element.
 * @return {*}
 */
function getBranchOrder( el ) {

    var order;

    if ( el ) {
        // Get the branch node
        var branch = el.parents(".node-depth-1");

        if ( branch ) {
            var className = branch.attr("class");

            if ( className ) {
                // Parse classes on the branch element to find the order
                var orderClass = className.split('node-branch-');

                if ( orderClass && orderClass.length > 1 ) {
                    var orderString = orderClass[ 1 ];
                    if ( Number.isInteger( Number(orderString ) ) ) {
                        order = Number( orderString );
                    }
                }
            }
        }
    }

    return order;
}

/**
 * Show the next/previous page of the hierarchy (tree) viewer.
 * @param e {object} Pagination arrow element click event.
 * @param regionid {string} Parent element id in which the content will be rendered.
 */
function hierarchyPaginationListener( e, regionid ) {

    e.preventDefault();

    var target = $( e.currentTarget );

    if ( target ) {

        var previous = target.hasClass("pull-left");
        var next = target.hasClass("pull-right" );

        var numberOfPages = getNumberOfPages( target );
        var order = getBranchOrder( target );

        // Get all hierarchy viewer branches

        var branchPages = getBranchPages();

        // Construct branch pages string expected by the Query Manager Web service
        var branchPagesString = '';
        var pagechange = false;

        if ( branchPages ) {
            for (var k = 0; k < branchPages.length; k++ ) {

                var branch = branchPages[ k ];

                if ( branch ) {

                    if ( branch.order === order ) {

                        var branchpage = branch.page;

                        // Previous page click
                        if ( previous && ! next && branchpage > 1 ) {

                            branch.page--;
                            pagechange = true;

                        }

                        // Next page click
                        if ( next && ! previous && branchpage < numberOfPages ) {

                            branch.page++;
                            pagechange = true;
                        }
                    }

                    branchPagesString += branch.page;
                    if ( k < branchPages.length - 1 ) {
                        branchPagesString += '-';
                    }
                }
            }
        }


        // Call Query Manager UI with updated branch pages

        if ( branchPagesString && App && App.globalState && pagechange ) {

            var alias = App.globalState.alias;
            var type = App.globalState.documentType;
            var id = App.globalState.documentId;

            if (  alias && type && id ) {

                // Remove current graph region
                // removePageContent( 'graph-content');
                removePageContent( regionid );
                // Get updated graph region
                displayRecordGraph( alias, type, id, branchPagesString, regionid, 1 );
            }
        }
    }
}

/**
 * Get hierarchy tree branches array of objects with current page and total number of pages for each branch.
 * @return {Array}
 */
function getBranchPages() {
    var result = [];

    /**
     * branches: [ { page: number, total: number, order: number}, {page: number, total: number, order: number}, ... ]
     */
    var branches = $('#hierarchy-container .node-depth-1');


    if ( branches ) {
        for ( var i = 0; i < branches.length; i++ ) {
            var branch = branches[i];


            if ( branch && $(branch) ) {
                var pagination = $(branch).find('.tree-pagination');

                var branchPages = {};


                // console.log(pagination);
                var controls = pagination.children();

                if ( controls && controls.length > 0 ) {
                    var icon = controls[0];

                    var pageNumber = getCurrentPageNumber( $(icon) );

                    var numberOfPages = getNumberOfPages( $( icon ));

                    var order = getBranchOrder( $(icon) );


                    if ( Number.isInteger(pageNumber) ) {
                        branchPages.page = pageNumber;
                    }

                    if ( Number.isInteger( numberOfPages ) ) {
                        branchPages.total = numberOfPages;
                    }

                    if ( Number.isInteger( order )) {
                        branchPages.order = order;
                    }
                } else {
                    // There are fewer than 5 nodes and no pagination is visible
                    branchPages.page = 1;

                }

                // Add branch pages object to the return array
                result.push( branchPages );
            }
        }
    }

    return result;
}